import {Box, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {getNodeInternalUrl} from "../../../constants/appRoutes";
import {NodeVisibility} from "../../../model/IHubMinimalNode.d.ts";
import ButtonSelect from "../../button-select";

const NodeTitle = ({name, code, fontSize, className}) => (
  <Box
    component="span"
    className={className}
    sx={{
      fontSize: fontSize ? fontSize : "20px",
      fontWeight: 500,
      textTransform: "none",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }}
  >
    {name || code}
  </Box>
);

const NodeSelector = ({isDefaultUniqueNode, node, nodes, fontSize}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  return (
    <Grid className="node-selector">
      {isDefaultUniqueNode ? (
        <NodeTitle name={node?.name} fontSize={fontSize} className="node-selector--single-node" />
      ) : (
        <ButtonSelect
          value={
            <NodeTitle
              name={node?.name}
              code={node?.code}
              fontSize={fontSize}
              className="node-selector--multiple-nodes"
            />
          }
          onChange={code => navigate(getNodeInternalUrl(code))}
          tooltip={node?.name}
          buttonStyle={{maxWidth: "100%"}}
          ariaLabel={t("components.header.actions.nodeSelector.ariaLabel")}
        >
          {nodes
            .filter(({visible}) => visible !== NodeVisibility.No)
            .sort((a, b) => a.order - b.order)
            .map(({code, name}, i) => (
              <span key={i} data-value={code}>
                {name || code}
              </span>
            ))}
        </ButtonSelect>
      )}
    </Grid>
  );
};

export default NodeSelector;
